import React, {useEffect, useRef} from 'react';
import {StyleSheet, Animated, Easing, View} from 'react-native';

const AnimatedArrow = () => {
  const translateY = useRef(new Animated.Value(0)).current;
  const scale = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    const anim = Animated.loop(
      Animated.parallel([
        Animated.sequence([
          Animated.timing(translateY, {
            toValue: 6,
            duration: 500,
            easing: Easing.out(Easing.quad),
            useNativeDriver: true,
          }),
          Animated.timing(translateY, {
            toValue: 0,
            duration: 500,
            easing: Easing.out(Easing.quad),
            useNativeDriver: true,
          }),
        ]),
        Animated.sequence([
          Animated.timing(scale, {
            toValue: 1.2,
            duration: 500,
            useNativeDriver: true,
          }),
          Animated.timing(scale, {
            toValue: 1,
            duration: 500,
            useNativeDriver: true,
          }),
        ]),
      ]),
    );

    anim.start();
    return () => anim.stop();
  }, []);

  return (
    <Animated.View
      style={[
        styles.arrowWrap,
        {
          transform: [{translateY}, {scale}],
        },
      ]}
    >
      {/* Arrow Shape */}
      <View style={styles.arrowHead} />
      <View style={styles.arrowStem} />
    </Animated.View>
  );
};

export default AnimatedArrow;

const styles = StyleSheet.create({
  arrowWrap: {
    position: 'absolute',
    bottom: -18,
    left: 60,
    alignItems: 'center',
  },

  arrowStem: {
    width: 3,
    height: 13,
    backgroundColor: '#2563eb',

    shadowColor: '#3b82f6',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.38,
    shadowRadius: 10,
    elevation: 8,
    borderRadius: 2,
  },

  arrowHead: {
    width: 13,
    height: 13,
    borderLeftWidth: 3,
    borderBottomWidth: 3,
    borderColor: '#2563eb',

    shadowColor: '#3b82f6',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.38,
    shadowRadius: 10,
    elevation: 8,
    transform: [{rotate: '315deg'}],
    marginBottom: -14,
  },
  upperView: {
    marginTop: 2, // যত আছে
    zIndex: 1, // বা 0
    pointerEvents: 'none', // ← এটা সবচেয়ে জরুরি (web এ খুব কাজ করে)
    // অথবা
    // pointerEvents: 'box-none',
  },
});
